import styled, { css } from 'styled-components';
import {
    BorderRadiusSmall,
    FontHeading2FamilySerif,
    FontHeading2LineHeight,
    FontOverlineSizeLarge,
    Spacing16
} from 'autogen/design-tokens/tokens';
import type { ConnectedContentWidthType, TextAlignmentType } from 'autogen/swagger/all';
import PageAction from 'components/shared/Routing/PageAction';
import { em, rem } from 'modules/helpers/style';
import ReactBackgroundImage from 'modules/react-backgroundImage';
import { colors } from 'variables';

export const PageActionWrapper = styled(PageAction)<{
    isPreview: boolean;
    $widthType: ConnectedContentWidthType | undefined;
}>`
    position: relative;
    display: flex;
    height: 100%;
    cursor: pointer;
    min-height: ${({ $widthType }): number => ($widthType === 'One' ? 388 : 430)}px;

    grid-column: ${({ $widthType }) => {
        switch ($widthType) {
            case 'One':
                return 'span 1';
            case 'Two':
                return 'span 2';
            default:
                return 'span 1';
        }
    }};

    /* Admin preview breakpoint simulator */
    ${({ isPreview, $widthType }) =>
        isPreview &&
        css`
            .preview--mobile-small & {
                width: ${rem($widthType === 'One' ? 148 : 304)};
            }

            .preview--mobile-large & {
                width: ${rem($widthType === 'One' ? 195 : 398)};
            }

            .preview--desktop-small & {
                width: ${rem($widthType === 'One' ? 220 : 448)};
            }

            .preview--desktop-large & {
                width: ${rem($widthType === 'One' ? 300 : 560)};
            }
        `}
`;

export const Container = styled.div<{ backgroundColor: string }>`
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.ColorBackgroundPrimary};
    color: ${({ theme }) => theme.ColorTextSecondary};
    padding: ${Spacing16};
`;

export const TextContainer = styled.div<{
    textAlignmentType: TextAlignmentType;
    widthType?: ConnectedContentWidthType;
}>`
    display: flex;
    flex-direction: column;
    flex: 1;
    text-align: center;
    ${({ widthType }) =>
        widthType === 'Two' &&
        css`
            justify-content: center;
        `}
    ${({ textAlignmentType }) => textAlignmentType === 'Left' && 'text-align: left;'}
    ${({ textAlignmentType }) => textAlignmentType === 'Right' && 'text-align: right;'}
    word-break: break-word;
`;

export const Heading = styled.div<{ color: string }>`
    font-size: ${FontOverlineSizeLarge};
    letter-spacing: 2px;
    text-transform: uppercase;
`;

export const Text = styled.div<{ color: string; widthType?: ConnectedContentWidthType }>`
    font-size: ${({ widthType }) => (widthType === 'Two' ? rem(24) : rem(20))};
    line-height: ${FontHeading2LineHeight};
    font-family: ${FontHeading2FamilySerif};
    font-weight: 700;
`;

interface IButton {
    ctaButtonColor?: string;
    ctaTextColor?: string;
    ctaBorderColor?: string;
}

export const Button = styled.div<IButton>`
    width: 100%;
    padding: ${em(15)};
    margin: 0 15px;
    line-height: ${em(13)};
    text-align: center;
    ${({ ctaButtonColor }) =>
        ctaButtonColor
            ? css`
                  background-color: ${ctaButtonColor};
              `
            : css`
                  text-decoration: underline;
                  text-decoration: underline;
                  font-weight: bold;
              `}
    ${({ ctaBorderColor }) =>
        ctaBorderColor
            ? css`
                  border: 1px solid ${ctaBorderColor};
              `
            : css`
                  border: none;
              `}
    border-radius: ${BorderRadiusSmall};
`;

export const backgroundImageStyling = css`
    position: absolute;
    top: 0;
    left: 0;
    max-width: 100%;
    max-height: 100%;
    background-position: top center;
`;
export const BackgroundImage = styled(ReactBackgroundImage)`
    ${backgroundImageStyling}
`;
